import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import * as GlobalErrorActions from '../../actions/globalerror';

class GlobalErrorDialog extends React.Component {

    render() {

        const errors = this.props.globalError.errors;

        const errorsHtml = errors.map((e,i) => {
            const errorNumberHtml = e.serverErrorId == -1 ? "" : <div style={{fontStyle: "italic", paddingBottom: "20px"}}>Error ID: {e.serverErrorId}</div>;
            const dividerHtml = i < errors.count()-1 ? <hr/> : "";
            return (
                <div key={e.errorId}>
                    <h2>{e.errorTitle}</h2>
                    <div style={{paddingTop:"14px", paddingBottom:"14px"}}>{e.errorMessage}</div>
                    {errorNumberHtml}
                    {/*<button type="submit" className="btn-1" onClick={() => this.closeSingleError(e.errorId)}>OK</button>*/}
                    {dividerHtml}
                </div>
            )
        });

        const modalDialogHtml = (
            <ReactModal isOpen={!errors.isEmpty()} shouldCloseOnOverlayClick={false} style={GlobalErrorDialog.modalDialogStyles}>
                <div className="modalDialogContent">
                    {errorsHtml}
                    <button type="submit" className="btn-primary" onClick={() => this.closeAllErrors()}>OK</button>
                </div>
            </ReactModal>
        );


        return (
            <div>
                {modalDialogHtml}
            </div>
        );
    }

    closeSingleError = errorId => {
        this.props.dispatch(GlobalErrorActions.removeGlobalError(errorId));
    };

    closeAllErrors = () => {
        this.props.dispatch(GlobalErrorActions.removeAllGlobalErrors());
    };

    static modalDialogStyles = {
        overlay : {
            position        : 'fixed',
            top             : 0,
            left            : 0,
            right           : 0,
            bottom          : 0,
            backgroundColor : 'rgba(0, 0, 0, 0.75)',
            zIndex          : 99999
        },
        content : {
            position                : 'absolute',
            top                     : '40px',
            left                    : '40px',
            right                   : '40px',
            bottom                  : '40px',
            border                  : "0px",
            background              : "none",
            overflow                : 'auto',
            WebkitOverflowScrolling : 'touch',
            borderRadius            : '0px',
            outline                 : 'none',
            padding                 : '20px',
            textAlign               : "center"
        }
    };

}

const mapStateToProps = (state) => ({
    globalError : {
        errors : state.globalError.errors
    }
});


export default connect(mapStateToProps)(GlobalErrorDialog);





// WEBPACK FOOTER //
// ./src/client/src/components/misc/GlobalErrorDialog.js